export default __webpack_public_path__ + "static/media/client-5.1698e217.png";